import ReservationService from '@/services/reservation.service'

export default {
  namespaced: true,
  state: () => ({
    filters: { store_id: null, direction: '', search: '' },
    items: [],
    loading: false,
    error: null,
    fixStatus: null,
  }),
  getters: {
    filteredItems(state) {
      const s = (state.filters.search || '').toLowerCase()
      const dir = state.filters.direction
      return state.items.filter((row) => {
        if (dir === 'over' && Number(row.mismatch) <= 0) return false
        if (dir === 'under' && Number(row.mismatch) >= 0) return false
        if (!s) return true
        const hay = `${row.sku || ''} ${row.store_name || ''} ${row.product_id} ${row.store_id}`.toLowerCase()
        return hay.includes(s)
      })
    },
    affectedStores(state) {
      const set = new Set(state.items.map((r) => r.store_id))
      return set.size
    },
    worstMismatch(state) {
      let worst = 0
      state.items.forEach((r) => {
        const abs = Math.abs(Number(r.mismatch) || 0)
        if (abs > worst) worst = abs
      })
      return worst
    },
  },
  mutations: {
    SET_FILTER(state, patch) {
      state.filters = { ...state.filters, ...patch }
    },
    SET_ITEMS(state, items) {
      state.items = items
    },
    SET_LOADING(state, value) {
      state.loading = value
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_FIX_STATUS(state, status) {
      state.fixStatus = status
    },
  },
  actions: {
    async fetchList({ commit, state }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const res = await ReservationService.listReconcile(state.filters.store_id)
        const payload = (res && res.data) || {}
        commit('SET_ITEMS', payload.mismatches || [])
      } catch (e) {
        const code = e.response && e.response.data && e.response.data.code
        commit('SET_ERROR', code || e.message || 'failed to fetch reconcile data')
        commit('SET_ITEMS', [])
      } finally {
        commit('SET_LOADING', false)
      }
    },
    setFilter({ commit, dispatch }, patch) {
      commit('SET_FILTER', patch)
      if (patch.store_id !== undefined) dispatch('fetchList')
    },
    async fixStore({ commit, dispatch }, { store_id, direction, limit }) {
      commit('SET_FIX_STATUS', { loading: true, store_id })
      try {
        const res = await ReservationService.reconcileFix({ store_id, direction, limit })
        commit('SET_FIX_STATUS', { loading: false, store_id, result: res && res.data })
        dispatch('fetchList')
        return res && res.data
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.error) || e.message
        commit('SET_FIX_STATUS', { loading: false, store_id, error: msg })
        throw e
      }
    },
  },
}
